import { jsx as r, Fragment as c, jsxs as a } from "react/jsx-runtime";
import { useTranslation as p } from "react-i18next";
import d from "next/image";
import u from "markdown-to-jsx";
import t from "@mui/material/Box";
import h from "@mui/material/Container";
import s from "@mui/material/Grid";
import i from "@mui/material/Typography";
import { makeStyles as f } from "tss-react/mui";
import { manageSmoothScrolling as g } from "../../../../../utils/index.js";
import y from "../../../../common/Button/Button.js";
import x from "./Banner.style.js";
const B = f()(x), b = ({ title: o, subTitle: n }) => {
  const { classes: e } = B(), { t: m } = p(), l = () => {
    g("#reservationForm");
  };
  return /* @__PURE__ */ r(c, { children: /* @__PURE__ */ a(t, { py: { xs: 12 }, className: e.wrapper, children: [
    /* @__PURE__ */ r(t, { className: e.bgWrap, children: /* @__PURE__ */ r(
      d,
      {
        alt: "Lumi Bus Banner Bg",
        src: "/images/png/search-back.jpg",
        layout: "fill",
        objectFit: "cover",
        quality: 100,
        priority: !0
      }
    ) }),
    /* @__PURE__ */ r(h, { children: /* @__PURE__ */ r(s, { container: !0, children: /* @__PURE__ */ r(s, { item: !0, xs: 12, children: /* @__PURE__ */ a(t, { py: { xs: 2 }, className: e.bannerContent, children: [
      o && /* @__PURE__ */ r(i, { mb: { xs: 3 }, className: e.title, children: o }),
      n && /* @__PURE__ */ r(
        i,
        {
          variant: "h5",
          mb: { xs: 5 },
          className: e.subTitle,
          children: /* @__PURE__ */ r(u, { children: n })
        }
      ),
      /* @__PURE__ */ r(
        y,
        {
          fullWidth: !0,
          dataTestid: "busRentalBannerQuote",
          className: e.quoteBtn,
          onClick: l,
          children: m("get_a_quote!")
        }
      )
    ] }) }) }) })
  ] }) });
}, _ = b;
export {
  _ as default
};
